import { DefaultPanel } from '../gadgets/panel';
import { Forms } from '../gadgets/forms';
import { Table } from '../gadgets/table';
import { API } from '../libs/api';
import { PageOptions, Pager } from '../libs/pager.class';
import { SimpleSelect } from '../gadgets/simpleSelect';
import { Tools, UserInfo } from '../libs/statics';
import { Row } from '../gadgets/row';
import { ALERT } from '../libs/alerts';
var UserPage = /** @class */ (function () {
    function UserPage() {
    }
    UserPage.prototype.run = function (finish) {
        PageOptions.setTitle("Buntzerverwaltung", "Hier können Sie Benutzer verwalten und ihre Rollen einstellen");
        API.getData("users/list/roles", function (result) {
            var names = [];
            result.roles.forEach(function (entry) {
                names.push([entry.role_name, entry.id]);
            });
            result.users_list.forEach(function (entry) {
                entry.role_data = result.roles;
                entry.role_name = result.roles[entry.role].role_name;
                entry.role_names = names;
            });
            var panel = new DefaultPanel("Benutzerkonten", undefined, true);
            var addUserPanel = new DefaultPanel("Neuer Benutzer", undefined, true);
            var mainRow = new Row();
            var table = new Table("usertable", result.users_list);
            var simpleSelectActive = undefined;
            var simpleSelectRole = undefined;
            var forms = new Forms();
            table.setColumns([
                { name: "Nachname", data: 'surname' },
                { name: "Vorname", data: 'name' },
                { name: "Geburtstag", data: 'birthdate' },
                { name: "E-Mail", data: 'email', style: "width: 100%" }
            ], true);
            panel.addGadget(table);
            addUserPanel.setHtml(forms.createFloatingInputs([
                ["vorname", "Vorname", "text"],
                ["nachname", "Nachname", "text"],
                ["email", "E-Mail", "email"],
                ["birth", "Geburtstag", "text"],
                ["role", "Rolle", { type: "select", data: names }],
                ["addUserBtn", "Hinzufügen", "button"]
            ]));
            mainRow.addCustomGadget(panel, 'col-xl-9');
            mainRow.addCustomGadget(addUserPanel, 'col-xl-3');
            mainRow.appendToContent(function () {
                $('#addUserBtn').on('click', function (e) {
                    e.preventDefault();
                    var passwd = Tools.generatePassword(10);
                    var vname = $('#vorname').val();
                    var nname = $('#nachname').val();
                    var email = $('#email').val();
                    var role = $('#role').val();
                    var birthdate = $('#birth').val();
                    if (vname != "" && nname != "" && email != "" && birthdate != "") {
                        var toSend_1 = [
                            ["name", vname],
                            ["surname", nname],
                            ["email", email],
                            ["birthdate", birthdate],
                            ["active", "1"],
                            ["role", role],
                            ["password", passwd]
                        ];
                        //console.log(toSend)
                        API.getData("users/list/w:email:".concat(email), function (_check) {
                            if (_check.users_list.length === 0) {
                                ALERT.showSimple(passwd, "Dies ist das Passwort für das angelegte Konto", "info", "Ok", false, function () {
                                    API.insertData("users", toSend_1, null, function () {
                                        Pager.loadPage("users");
                                    });
                                });
                                return;
                            }
                            ALERT.showSimple("E-Mail", "E-Mail Adresse bereits vergeben!", "warning");
                        });
                        return;
                    }
                    ALERT.showSimple("Eingabe beachten", "Bitte füllen Sie alle Felder aus!", "warning");
                });
            });
            table.execute(function () {
                table.onRowClick(function (data) {
                    var delUserHtml = "<a href=\"#\" data-del-user='".concat(data.id, "' data-username='").concat(data.name, " ").concat(data.surname, "'>Konto entfernen</a>");
                    //console.log(data)
                    forms = new Forms();
                    simpleSelectRole = new SimpleSelect('ssl-roleid-' + data.id, data.role_names);
                    simpleSelectActive = new SimpleSelect('ssl-activeid-' + data.id, [["Deaktiviert", "0"], ["Aktiviert", "1"]]);
                    simpleSelectRole.Select(data.role_name);
                    simpleSelectActive.Select(data.active === 1 ? "Aktiviert" : "Deaktiviert");
                    if (UserInfo.id == data.id) {
                        simpleSelectRole.disable();
                        simpleSelectActive.disable();
                        delUserHtml = '';
                    }
                    var _row = new Row();
                    _row.addCustomGadget("<dt>Konto ist</dt><dd>".concat(simpleSelectActive.render(), "</dd><dt>Rolle</dt><dd>").concat(simpleSelectRole.render(), "</dd>"), 'col-xl-5');
                    _row.addCustomGadget("<dt>Passwort \u00E4ndern</dt><dd>".concat(forms.passwordChangeFormLite('userpass', UserInfo.id == data.id), "</dd>"), 'col-xl-5');
                    return "<div class=\"grid-3-1\"><div class=\"grid-item\"><dt>Nutzer-ID</dt><dd>".concat(data.id, "</dd><dt>Letzter Login</dt><dd>").concat(data.last_login ? data.last_login : "-", "</dd><dt>IP-Addresse</dt><dd>").concat(data.last_ip, "</dd></div><div class=\"grid-item\">").concat(_row.render(), "</div><div class=\"grid-item\" style=\"text-align: right\">").concat(delUserHtml, "</div></div>");
                }, function (data) {
                    if (UserInfo.id == data.id)
                        return;
                    forms.onPasswordInputChange('userpass');
                    $('#userpass_savebtn').on('click', function (e) {
                        e.preventDefault();
                        var newPass = $('#userpass_confirm').val();
                        if (newPass.length >= 6) {
                            API.updateData("users", data.id, [["password", newPass], ["force_logout", "1"]], null, function () {
                                $('#userpass_password').val('');
                                $('#userpass_confirm').val('');
                                $("#userpass_savebtn").attr('disabled', "true");
                            });
                        }
                        else {
                            ALERT.showSimple("Passwort zu kurz!", "Das Passwort muss mindestens 6 Zeichen enthalten", "error");
                        }
                    });
                    $('[data-del-user]').on('click', function (e) {
                        var _e = $(e.target);
                        var name = _e.data('username');
                        var id = _e.data('del-user');
                        ALERT.showConfirm("Konto Löschung", "Es wird empfohlen das Konto zu deaktivieren. M\u00F6chten Sie das Konto von \"".concat(name, "\" wirklich l\u00F6schen?"), function () {
                            API.deleteData("users", id, null, function () {
                                Pager.loadPage("users");
                            });
                        });
                        e.preventDefault();
                    });
                    simpleSelectRole.onChange(function (val) {
                        data.role = val;
                        data.role_name = names[val][0];
                        API.updateData("users", data.id, [["role", val], ["force_logout", "1"]]);
                    });
                    simpleSelectActive.onChange(function (val) {
                        data.active = parseInt(val);
                        API.updateData("users", data.id, [["active", val], ["force_logout", "1"]]);
                    });
                });
                finish();
            });
        });
    };
    return UserPage;
}());
export { UserPage };
